import { MEDIA_QUERIES } from '../constants';

type MediaQueryListenerCallback = Parameters<MediaQueryList['addListener']>[0];
const getMediaQueryList = (mediaQuery: string, listener?: MediaQueryListenerCallback) => {
  let mediaQueryList: MediaQueryList | null = null;

  if (typeof window !== 'undefined' && mediaQuery && typeof mediaQuery === 'string') {
    mediaQueryList = window.matchMedia(mediaQuery);
    // Register a media query list listener
    if (listener && typeof listener === 'function') {
      mediaQueryList.addListener(listener);
    }
  }

  return mediaQueryList;
};

const isMobile = () => {
  const mql = getMediaQueryList(MEDIA_QUERIES.MOBILE);

  return mql && mql.matches;
};

export default isMobile;
